import { render, staticRenderFns } from "./ChangesNotSaved.vue?vue&type=template&id=0b41e83e&"
import script from "./ChangesNotSaved.vue?vue&type=script&lang=js&"
export * from "./ChangesNotSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports